import nextPageIcon from '../../assets/images/right-arrow-blue.svg';
import prevPageIcon from '../../assets/images/left-arrow-blue.svg';

const Pagination = ({
                        pages = 5,
                        currentPage = 1,
                        onPageChange = (num) => {}
                    }) => {

    const getPagesCut = ({pagesCount, pagesCutCount, currentPage}) => {
        const ceiling = Math.ceil(pagesCutCount / 2);
        const floor = Math.floor(pagesCutCount / 2); 
        // console.log(ceiling, floor)
        if(pagesCount < pagesCutCount) {
            let startEnd = { start : 0, end : pagesCount};
            // console.log(startEnd);
            return startEnd;
        } else if (currentPage >= 1 && currentPage <= ceiling){
            let startEnd =  {start : 0, end : pagesCutCount};
            // console.log(startEnd);
            return startEnd;
        } else if(currentPage + floor >= pagesCount) {
            let startEnd =  {start : pagesCount - pagesCutCount, end : pagesCount};
            // console.log(startEnd);
            return startEnd;
        } else {
            let startEnd =  {start : currentPage - ceiling -1, end : currentPage + floor};
            // console.log(startEnd);
            return startEnd;
        }
    }
    const pageCutCount = 10;
    const pageCut = getPagesCut({pagesCount: pages, pagesCutCount: pageCutCount, currentPage});
    const allPages = [...Array(pageCut.end - pageCut.start).keys()].map((el) => el + pageCut.start);

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        const totalPages = pages;
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };
    const handleFirstPage = () => {
        onPageChange(1);
    };
    const handleLastPage = () => {
        const totalPages = pages;
        onPageChange(totalPages);
    };

    return (
        <ul className={'pagination'}>
        {/* <li><button className="pagination-link" onClick={e => handleFirstPage()} disabled={currentPage === 1}><img src={firstPageIcon} alt="First Page Icon"></img></button></li> */}
            <li><button className="pagination-link" onClick={e => handlePreviousPage()} disabled={currentPage - 1 === 0}><img src={prevPageIcon} alt="Prev page Icon"></img></button></li>
            {allPages.map((page) =>
                <li key={page} className={`${currentPage === page + 1 ? 'active' : ''}`}
                    onClick={e => onPageChange(page + 1)}>{page + 1}</li>
            )}
            <li><button className="pagination-link" onClick={e => handleNextPage()} disabled={currentPage === pages}><img src={nextPageIcon} alt="Next Page Icon"></img></button></li>
            {/* <li><button className="pagination-link" onClick={e => handleLastPage()} disabled={currentPage === pages}><img src={lastPageIcon} alt="Last Page Icon"></img></button></li> */}
        </ul>
    )
}

export default Pagination;
